import { render } from "./bindMobile.vue?vue&type=template&id=1586af08&scoped=true"
import script from "./bindMobile.vue?vue&type=script&lang=js"
export * from "./bindMobile.vue?vue&type=script&lang=js"

import "./bindMobile.vue?vue&type=style&index=0&id=1586af08&lang=scss&scoped=true"

import exportComponent from "/root/workspace/zyy-iot_zyy-iot-web-v2_T3ED/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1586af08"]])

export default __exports__